import { PIN_LAYOUTS, PIN_STANDARD } from 'constants-content';
import { Primitive } from '../../../types/blocks/Primitive';

const SectionsOnChannelBlock: Primitive = {
  name: 'SectionsOnChannelBlock',
  friendlyName: 'Sections on Channel',
  isAvailableInEditor: true,
  isInput: false,
  isPrimitive: true,
  tags: ['Other'],
  properties: {
    channel: {
      friendlyName: 'Channel',
      type: 'Channel',
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
    },
    header: {
      friendlyName: 'Title',
      type: 'String',
      validators: [
        {
          name: 'Max',
          value: 80,
        },
      ],
    },
    listView: {
      friendlyName: 'Pin View',
      type: 'String',
      default: PIN_STANDARD,
      validators: [
        {
          name: 'In',
          value: PIN_LAYOUTS,
        },
      ],
    },
    autoHide: {
      friendlyName: 'Hide when no results',
      type: 'Boolean',
      default: true,
    },
  },
  publishes: {
    // @ts-expect-error ts-migrate(2741) FIXME: Property 'action' is missing in type '{ type: "Eve... Remove this comment to see the full error message
    click: {
      type: 'Event',
    },
  },
};

export default SectionsOnChannelBlock;
